import { VirtualScroller } from "../VirtualScroller/VirtualScroller";
import {
  WebGLCarouselRendererProps,
  CarouselLoadingState,
} from "./WebGLCarouselRenderer.types";
import { useCallback } from "react";
import { TileTitle } from "../Tile/TileTitle";
import { WebGLContainer } from "../common";

export function WebGLCarouselRenderer({
  loadingState,
  ...virtualScrollerProps
}: WebGLCarouselRendererProps) {
  const renderErrorState = useCallback(
    () => (
      <WebGLContainer blendMode="multiply" tint={0x000000}>
        <TileTitle
          text="Error loading carousel"
          fontSize={24}
          color="white"
          position={{ x: 100, y: 100 }}
        />
        <VirtualScroller {...virtualScrollerProps} />
      </WebGLContainer>
    ),
    [virtualScrollerProps]
  );

  // Render default state with VirtualScroller
  const renderDefaultState = useCallback(
    () => <VirtualScroller {...virtualScrollerProps} />,
    [virtualScrollerProps]
  );

  // Render map for different loading states - lazy evaluation approach
  const renderMap = {
    [CarouselLoadingState.LOADING]: () => renderDefaultState(),
    [CarouselLoadingState.ERROR]: () => renderErrorState(),
    [CarouselLoadingState.LOADED]: () => renderDefaultState(),
  };

  return renderMap[loadingState]?.();
}
